module.exports = __webpack_public_path__ + "images/masterpass.8227c7a6b27e5b34b46c3ae734eb5918.svg";